import {
	AmplitudeCustomerData,
	FullstoryCustomerData,
	PendoAccount,
	PendoVisitor
} from '@sonar-software/sonar-analytics';
import { Customer, User } from '@sonar-software/sonar-core';

export function convertUserToAmplitudeCustomerData(
	user: User,
	currentCustomer: Customer,
	orgCount: number,
	userCount: number
): AmplitudeCustomerData {
	const { email } = user;
	const { name, id } = currentCustomer;

	return {
		customer: `${name}-${id}`,
		email,
		orgCount,
		userCount
	};
}

export function convertDataToFullstoryData(user: User, currentCustomer: Customer): FullstoryCustomerData {
	const { email, firstName, lastName, id: userId } = user;
	const { name, id } = currentCustomer;

	return {
		customerOrg: name,
		customerOrgId: String(id),
		email,
		name: `${firstName} ${lastName}`,
		uid: userId.toString()
	};
}

export function convertUserToPendoVisitor(user: User, shard: string): PendoVisitor {
	const { email, firstName, lastName, id } = user;

	return {
		email,
		// eslint-disable-next-line camelcase
		full_name: `${firstName} ${lastName}`,
		id: shard ? `${shard}:${id}` : id.toString()
	};
}

export function convertCustomerToPendoAccount(customer: Customer, shard: string): PendoAccount {
	const { id, name, salesforceAccountId } = customer;

	return {
		id: shard ? `${shard}:${id}` : String(id),
		name,
		salesforceAccountId: salesforceAccountId ?? ''
	};
}
